import { useHistory, useLocation } from 'react-router-dom';

import { PANEL_QUERY_KEY, PUBLIC_PANEL_VALUES } from '../constants/panel.constants';

type UsePanelResult = {
  activePanel: string | null;
  openPanel: (panel: string) => void;
  replacePanel: (panel: string) => void;
  closePanel: () => void;
};

export function usePanel(): UsePanelResult {
  const history = useHistory();
  const location = useLocation();

  const requested = new URLSearchParams(location.search).get(PANEL_QUERY_KEY);
  const activePanel = requested !== null && PUBLIC_PANEL_VALUES.indexOf(requested) !== -1 ? requested : null;

  const buildSearch = (panel: string | null): string => {
    const params = new URLSearchParams(location.search);

    if (panel === null) params.delete(PANEL_QUERY_KEY);
    else params.set(PANEL_QUERY_KEY, panel);

    const search = params.toString();

    return search === '' ? '' : `?${search}`;
  };

  return {
    activePanel,
    openPanel: (panel: string) => history.push(`${location.pathname}${buildSearch(panel)}`),
    replacePanel: (panel: string) => history.replace(`${location.pathname}${buildSearch(panel)}`),
    closePanel: () => history.push(`${location.pathname}${buildSearch(null)}`),
  };
}
